import {createSignal} from '@pexip/signal';

export const ariaMenuOpenStateSignal = createSignal<boolean>({
    name: 'ariamenu:open-state',
});
